export default __webpack_public_path__ + "static/media/rusgo-screenshot-01.6646d8cc.png";